import { createSlice } from "@reduxjs/toolkit";
import { getAttributeById, getAttributeList } from "./ThunkAction";
import { iAttributeState, REDUCER_NAME } from "./Types"; 

// Define initial state based on the provided structure
const initialState: iAttributeState = {
  isLoading: false,
  attributeDetail: null, // Ensure this is a single object
  attributeList:[],
  errorMessage: null,
};
export const attributeSlice = createSlice({
  name: REDUCER_NAME, 
  initialState,
  reducers: {
    resetAttributeState: () => {
      return initialState; // Reset to the initial state
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAttributeById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAttributeById.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.attributeDetail = payload.data.attributes; 
          state.isLoading = false;
        }
      })
      .addCase(getAttributeById.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Attribute data";
        state.isLoading = false;
      })
      .addCase(getAttributeList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAttributeList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.attributeList = payload.data.attributes; 
          state.isLoading = false;
        }
      })
      .addCase(getAttributeList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Attribute data";
        state.isLoading = false;
      });
  },
});

export const { resetAttributeState } = attributeSlice.actions;
export default attributeSlice.reducer;
